import type { AvailableCatalog } from "@ext/enterprise/types/AvailableCatalog";

export type CatalogRow = {
	repo: string;
	title: string;
	description?: string;
};

export const toCatalogRow = (repo: string, catalog?: AvailableCatalog): CatalogRow => ({
	repo,
	title: catalog?.title || repo.split("/").pop() || repo,
	description: catalog?.description,
});

export const getCatalogLabel = (repo: string, catalog?: AvailableCatalog): string =>
	catalog?.title ? `${catalog.title} · ${repo}` : repo;
